import { Web3Provider } from '@ethersproject/providers'
import { InjectedConnector } from '@web3-react/injected-connector'
import { WalletConnectConnector } from '@web3-react/walletconnect-connector'
import { WalletLinkConnector } from '@web3-react/walletlink-connector'
import { PortisConnector } from '@web3-react/portis-connector'

import { FortmaticConnector } from './Fortmatic'
import { NetworkConnector } from './NetworkConnector'
import { ACTIVE_CHAIN_ID, getActiveChainConfig, getSupportedChainIds } from '../constants/chains'

const FORMATIC_KEY = process.env.REACT_APP_FORTMATIC_KEY
const PORTIS_ID = process.env.REACT_APP_PORTIS_ID

// Get active chain config
const activeChain = getActiveChainConfig()

// Network chain ID from centralized config
export const NETWORK_CHAIN_ID: number = ACTIVE_CHAIN_ID

// Network URL from centralized config
const NETWORK_URL = activeChain.rpcUrl

export const network = new NetworkConnector({
  urls: { [NETWORK_CHAIN_ID]: NETWORK_URL },
  defaultChainId: NETWORK_CHAIN_ID
})

let networkLibrary: Web3Provider | undefined
export function getNetworkLibrary(): Web3Provider {
  // Pass "any" as network to allow network changes without errors
  return (networkLibrary = networkLibrary ?? new Web3Provider(network.provider as any, 'any'))
}

// Supported chain IDs from centralized config
export const injected = new InjectedConnector({
  supportedChainIds: getSupportedChainIds()
})

// WalletConnect with active chain RPC
export const walletconnect = new WalletConnectConnector({
  rpc: { [NETWORK_CHAIN_ID]: NETWORK_URL },
  bridge: 'https://bridge.walletconnect.org',
  qrcode: true,
  pollingInterval: 15000
})

// mainnet only
export const fortmatic = new FortmaticConnector({
  apiKey: FORMATIC_KEY ?? '',
  chainId: 1
})

// mainnet only
export const portis = new PortisConnector({
  dAppId: PORTIS_ID ?? '',
  networks: [1]
})

// mainnet only
export const walletlink = new WalletLinkConnector({
  url: NETWORK_URL,
  appName: 'Minax DEX',
  appLogoUrl: 'https://sc.minax.io/dex/testnet/img/logo1.png'
})
